export { default as Relatorios } from "./Relatorios"
export { default as RelatorioGestorForm } from "./RelatorioGestorForm"
export { default as RelatorioFiscaisForm } from "./RelatorioFiscaisForm"
export { default as RelatorioObjetoForm } from "./RelatorioObjetoForm"
export { default as RelatorioVigenciasForm } from "./RelatorioVigenciasForm"
export {
  default as RelatorioVigenciasDiasRestantesForm
} from "./RelatorioVigenciasDiasRestantesForm"
export { default as RelatorioContratadosForm } from "./RelatorioContratadosForm"
export { default as RelatorioBaixasForm } from "./RelatorioBaixasForm"
export { default as RelatorioConsumoForm } from "./RelatorioConsumoForm"
export {
  default as RelatorioBaixasSinteticoForm
} from "./RelatorioBaixasSinteticoForm"
export { default as RelatorioAditivosForm } from "./RelatorioAditivosForm"
export {
  default as RelatorioDeContratosVencidosForm
} from "./RelatorioDeContratosVencidosForm"
export { default as RelatorioSaldoForm } from "./RelatorioSaldoForm"
export { default as RelatorioFinalSaldoForm } from "./RelatorioFinalSaldoForm"
export { default as RelatorioDistratosForm } from "./RelatorioDistratosForm"
export {
  default as RelatorioContratosGroupedByForm
} from "./RelatorioContratosGroupedByForm"



// WEBPACK FOOTER //
// ./src/views/relatorios/index.js